import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
//
import { dispatch } from "../store";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  mariage: null,
};

const slice = createSlice({
  name: "mariage",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET MARIAGE
    getMariageSuccess(state, action) {
      state.isLoading = false;
      state.mariage = action.payload;
    },

    // UPDATE MARIAGE
    updateMariageSuccess(state, action) {
      state.mariage = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { updateMariageSuccess } = slice.actions;

// ----------------------------------------------------------------------

export function getMariage() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/dashboard/mariages`);
      dispatch(slice.actions.getMariageSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function updateMariage(data) {
  const response = await axios.post(`/api/dashboard/mariages`, data);
  return response.data;
}

export async function deleteMariage(id) {
  const response = await axios.delete(`/api/dashboard/mariage/${id}`);
  return response.data;
}
